import { ComponentType } from 'react';
import { PersonalDataProvider } from './PersonalDataProvider';

export const withPersonalData = <P extends object>(Component: ComponentType<P>) => {
  const WrappedComponent = (props: P) => {
    return (
      <PersonalDataProvider>
        <Component {...props} />
      </PersonalDataProvider>
    );
  };

  WrappedComponent.displayName = `withPersonalData(${Component.displayName || Component.name})`;

  return WrappedComponent;
};
